import { fetchEmployee } from '@/api/business/employee'
import { useQuery } from '@tanstack/react-query'

export const EmployeeKeys = {
    all: ['employee'] as const,
    lists: () => [...EmployeeKeys.all, 'list'] as const,
    list: (page: number, perPage: number, filters: any) =>
        [...EmployeeKeys.lists(), page, perPage, filters] as const,
    details: () => [...EmployeeKeys.all, 'detail'] as const,
    detail: (params: string) => [...EmployeeKeys.details(), params] as const,
}

export const useEmployeeQuery = (SK_REVENDA: number, enableStatus: boolean) => {
    return useQuery({
        enabled: enableStatus,
        queryFn:  () => fetchEmployee(SK_REVENDA),
        queryKey: EmployeeKeys.lists(),
    })
}
